import { useEffect, useRef, useState } from 'react';

const POLL_INTERVAL_MS = 2 * 60 * 1000;

async function fetchCurrentBuildId(): Promise<string | null> {
  try {
    const res = await fetch(window.location.href, { cache: 'no-store' });
    if (!res.ok) {
      console.log('[version-check] page fetch failed:', res.status);
      return null;
    }
    const text = await res.text();
    const match = text.match(/"buildId":"([^"]+)"/);
    const buildId = match ? match[1] : null;
    console.log('[version-check] polled buildId:', buildId);
    return buildId;
  } catch (err) {
    console.log('[version-check] fetch error new:', err);
    return null;
  }
}

export function useVersionCheck() {
  const initialId = useRef<string | null>(null);
  const [isOutdated, setIsOutdated] = useState(false);

  useEffect(() => {
    initialId.current = (window as any).__NEXT_DATA__?.buildId ?? null;
    console.log('[version-check] initial buildId:', initialId.current);

    const interval = setInterval(async () => {
      const current = await fetchCurrentBuildId();
      console.log('[version-check] comparing:', { initial: initialId.current, current, outdated: current !== initialId.current });
      if (current && initialId.current && current !== initialId.current) {
        console.log('[version-check] new version detected — showing banner');
        setIsOutdated(true);
        clearInterval(interval);
      }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return isOutdated;
}
